import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, mlResourceIdFormat, mlResourceIdErrorMessage, getAzureMLControls } from './shared-control-metadata';

import { Metamodel } from 'shell-models-lib';
import { AzureMLServiceLinkedService } from 'app/model/linkedservice/azure-ml-service.linkedservice';

export const azureMLPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.MachineLearningServices/workspaces',
    connectionSuffix: 'privateConnections',
    resourceIdValidator: mlResourceIdFormat,
    groupIdMetadata: {
        amlworkspace: {
            linkedServiceType: Metamodel.modelFor(AzureMLServiceLinkedService).name,
            groupId: 'amlworkspace',
            iconClass: 'svg-i-100x100-azure_ml',
            displayName: stringResources.AzureMLService_DisplayText,
            controls: {
                creationControls: getAzureMLControls(),
                readonlyControls: getReadonlyControl(mlResourceIdFormat, mlResourceIdErrorMessage)
            }
        }
    }
};
